export default {"src":"/_next/static/media/share_icon.83d377c9.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};